/**
 * The embedded player the wall screens show for the welcome screen's video, or null when
 * `address` is not a link to one YouTube video. Used by the API to refuse it and by the screens to
 * draw it.
 *
 * Takes any YouTube link to one video - watch?v=, youtu.be/, /shorts/, /live/, /embed/. The player
 * is muted, since browsers only start a video on their own without sound, and loops, without
 * controls.
 */
export function youtubeEmbedUrl(address: string): string | null {
  let url: URL;
  try {
    url = new URL(address.trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  const host = url.hostname.replace(/^(www|m)\./, '');
  const id =
    host === 'youtu.be'
      ? url.pathname.split('/')[1]
      : host === 'youtube.com' || host === 'youtube-nocookie.com'
        ? url.pathname === '/watch'
          ? url.searchParams.get('v')
          : /^\/(?:shorts|live|embed)\/([^/]+)/.exec(url.pathname)?.[1]
        : null;
  if (!id || !/^[\w-]{11}$/.test(id)) return null;
  return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&rel=0&playsinline=1`;
}
